<div class="auth-main">
    <div class="auth-main__content">
        <img
            class="auth-main__mobile-logo"
            src="./assets/icons/auth/brand-logo.svg"
            alt="Логотип"
        />
        <div class="auth-main__title">
            <span>{{ AuthFormTitle }}</span>
        </div>

        <div class="auth-main__secondary registration-success">
            <div class="auth-main__icon">
                <img
                    src="./assets/icons/status/success.svg"
                    alt="Иконка успеха"
                />
            </div>
            <div class="auth-main__register-success">
                <span
                    >Вы успешно прошли регистрацию в личном кабинете
                    пациента!</span
                >
                <span
                    >Логин и пароль были отправлены в сообщении на указанную
                    Вами почту</span
                >
            </div>
        </div>
        <button
            type="button"
            class="form__submit registration-success__button"
            (click)="goToLogin()"
        >
            <span>Перейти к авторизации</span>
        </button>
    </div>
    <div class="auth-main__img">
        <img
            class="img-logo"
            src="./assets/icons/auth/brand-logo.svg"
            alt="Логотип"
        />
        <img
            class="img-doctor"
            src="./assets/icons/auth/login-illustration.svg"
            alt=""
        />
    </div>
</div>
